import { StoreConfig, Store, akitaConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

export enum Role {
	ADMIN = 'ADMIN',
	PRODUCT_ADMIN = 'PRODUCT_ADMIN',
	CLIENT = 'CLIENT',
	GROUP = 'GROUP',
	CARDHOLDER = 'CARDHOLDER',
	USER = 'USER'
}

export class UserInfo {
	id!: string;
	name!: string;
	email!: string;
	individualClient?: boolean;
	firstName!: string;
	roles!: Role[] | string[];
	clientId!: string;
	groupId!: string;
	cardholderId!: string;
	tagline?: string;
	realEstateFilters?: string[];
	showMlsRegistration?: boolean;

	pendingPayment!: boolean;
	suspendedPayment!: boolean;
	clientSuspensionDate!: Date;
	missingPlan?: boolean;
	pictureUrl?: string;

	/**
	 * @deprecated
	 */
	protected wasReferred?: boolean;

	/**
	 * @deprecated
	 */
	protected missingBillingInfo?: boolean;

	/**
	 * @deprecated
	 */
	protected hasPaidPlan?: boolean;

	// TODO -> this will be a new flag coming from back end that will replace these other two
	get pendingRegistration(): boolean {
		return !!this.missingPlan || (!!this.hasPaidPlan && !!this.missingBillingInfo);
	}

	// TODO -> this will be a new flag coming from back end that will replace these other two
	get hasPendingInviteDiscount(): boolean {
		return !!this.wasReferred && this.pendingRegistration;
	}

	get pendingMlsRegistration(): boolean {
		return !!this.showMlsRegistration;
	}

	get hasPendingOnboarding(): boolean {
		return this.pendingRegistration || this.pendingMlsRegistration;
	}

	hasRole(role: Role | string): boolean {
		if (!this.roles || this.roles.length === 0) {
			return false;
		}
		for (const r of this.roles) {
			if (r === role) {
				return true;
			}
		}
		return false;
	}

	hasAnyRole(...roles: Role[] | string[]) {
		return this.hasAnyRoleArr(roles);
	}

	hasAnyRoleArr(roles: (Role | string)[]) {
		if (roles === undefined || roles.length === 0) {
			return true;
		}

		for (const role of roles) {
			if (this.hasRole(role)) {
				return true;
			}
		}
		return false;
	}
}

export interface SessionState {
	isAuthenticated: boolean;
	userInfo: UserInfo | null;
}

export function createInitialState(): SessionState {
	return {
		isAuthenticated: false,
		userInfo: null
	};
}

akitaConfig({
	resettable: true
});

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'sessionState' })
export class SessionStore extends Store<SessionState> {
	constructor() {
		super(createInitialState());
	}

	clearSession(): void {
		this._setState(state => createInitialState());
	}
}
